import React, { Component, Fragment } from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME } from 'Common/FormEnum';
import {
  BidGroupEnum,
  AssignEntitiesEnum,
  FilterEnum,
  ItemEnum,
  SiteEnum,
} from 'Common/FieldEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { Main, Filter } from 'Containers';
import { DefaultTableState } from 'Common/Constants/table';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getStorageLocationForCurrentSite,
} from 'State/filters/actions';
import { LoadingPage, DirtyWrapper, NotificationDialog } from 'Components';
import { resetForm, submitForm } from 'State/forms/actions';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import * as FilterSelectors from 'State/filters/selectors';

import {
  BASE_URL,
  callApiBasedOnRenderComponent,
  ComponentMapping,
  getFilteredIds,
  getPayload,
  GridNames,
} from '../../../helper/assignEntities';
import {
  getItems,
  getAllSites,
  getSiteSiteGrpItemByStorageLoc,
  clearSubmitError,
  saveAssignEntities,
  getSiteGroupData,
  resetAssignEntitiesStoragePage,
} from '../../../state/assignEntities/actions';
import { StorageLocationForm } from './StorageLocationForm';
import * as Selectors from '../../../state/assignEntities/selectors';

import 'Styles/pages/utilities/assignentities/index.less';

class StorageLocation extends Component {
  static propTypes = {
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    getAllSites: PropTypes.func.isRequired,
    getSiteSiteGrpItemByStorageLoc: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    clearSubmitError: PropTypes.func.isRequired,
    saveAssignEntities: PropTypes.func.isRequired,
    getSiteGroupData: PropTypes.func.isRequired,
    resetAssignEntitiesStoragePage: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    clearTableSavedState: PropTypes.func.isRequired,
    allSitesLoadingError: PropTypes.array,
    allItemsLoadingError: PropTypes.array,
    siteGroupLoadingError: PropTypes.array,
    acctCategoryDataError: PropTypes.array,
    bidGroupDataError: PropTypes.array,
    itemGroupDataError: PropTypes.array,
    storageLocationDataError: PropTypes.array,
    storageLocationByIdLoadingError: PropTypes.array,
    submitError: PropTypes.array,
    assignedStorageLocationData: PropTypes.object,
    allTableStates: PropTypes.object.isRequired,
    storageLocationValue: PropTypes.number,
    sortOptionsValue: PropTypes.string,
    submitSuccessMsg: PropTypes.string.isRequired,
    fetchingDropDown: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    clearSubmitError: null,
    allSitesLoadingError: null,
    allItemsLoadingError: null,
    siteGroupLoadingError: null,
    acctCategoryDataError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    storageLocationDataError: null,
    storageLocationByIdLoadingError: null,
    submitError: null,
    assignedStorageLocationData: null,
    storageLocationValue: GenericEnum.InitialFilterValue,
    sortOptionsValue: AssignEntitiesEnum.Site,
  };
  static path = `${BASE_URL}/assignstoragelocation`;

  state = {
    render: {
      SiteToItemsComponentsWithStorageLocation: true,
    },
    isReadOnly: true,
    isRightGridFiltered: false,
    isLeftGridFiltered: false,
    showNoSitesModal: false,
    resetGridPage: {
      [GridNames.Site]: true,
      [GridNames.Item]: true,
    },
  };

  rightSideGridReactTableRef = React.createRef();
  leftSideGridReactTableRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { clearSubmitError, submitSuccessMsg } = this.props;

    errorToast(this.props, prevProps, 'siteGroupLoadingError');
    errorToast(this.props, prevProps, 'allSitesLoadingError');
    errorToast(this.props, prevProps, 'allItemsLoadingError');
    errorToast(this.props, prevProps, 'acctCategoryDataError');
    errorToast(this.props, prevProps, 'bidGroupDataError');
    errorToast(this.props, prevProps, 'itemGroupDataError');
    errorToast(this.props, prevProps, 'storageLocationDataError');
    errorToast(this.props, prevProps, 'storageLocationByIdLoadingError');

    if (errorToast(this.props, prevProps, 'submitError')) {
      clearSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', submitSuccessMsg, true);
      clearSubmitError();
    }
  }
  componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getStorageLocationForCurrentSite,
      getItems,
      getAllSites,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.AllOnly);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getStorageLocationForCurrentSite();
    getItems();
    getAllSites();
  }

  changeGrid = componentName => {
    const { getItems, getSiteGroupData, getAllSites } = this.props;
    const obj = {
      SiteToItemsComponentsWithStorageLocation:
        componentName ===
        ComponentMapping.SiteToItemsComponentsWithStorageLocation,
    };
    getItems();
    obj.SiteToItemsComponentsWithStorageLocation && getAllSites();
    !obj.SiteToItemsComponentsWithStorageLocation && getSiteGroupData();
    this.setState({
      render: obj,
      resetGridPage: {
        [GridNames.Site]: true,
        [GridNames.Item]: true,
      },
    });
  };
  onResetPageOnDataChange = resetGridPage => {
    resetGridPage && this.setState({ resetGridPage });
  };
  onCancelClick = () => {
    this.setState({
      isReadOnly: true,
    });
    this.props.resetAssignEntitiesStoragePage(
      this.props.assignedStorageLocationData
    );
  };

  getRootUrl = () => {
    return BASE_URL;
  };

  getMainProps = showDirtyConfirm => {
    const { isSubmitting, storageLocationValue } = this.props;
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        rightButtons: [
          {
            content: 'Cancel',
            onClick: showDirtyConfirm,
            disabled: !storageLocationValue,
          },
          {
            content: 'Save',
            onClick: this.onSaveClick,
            loading: isSubmitting,
            disabled: isSubmitting || !storageLocationValue,
          },
        ],
        shown: true,
      },
    };
  };
  handleSubmit = values => {
    const { assignedStorageLocationData } = this.props;
    const renderedComponent = this.state.render
      .SiteToItemsComponentsWithStorageLocation
      ? ComponentMapping.SiteToItemsComponentsWithStorageLocation
      : ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation;
    if (values.GroupId_Location) {
      let payload;
      let leftGridPayloadName =
        renderedComponent ===
        ComponentMapping.SiteToItemsComponentsWithStorageLocation
          ? AssignEntitiesEnum.SiteGridInfo
          : AssignEntitiesEnum.SiteGroupGridInfo;

      const {
        ItemGridInfo,
        SiteGridInfo,
        SiteGroupGridInfo,
      } = assignedStorageLocationData
        ? _.cloneDeep(assignedStorageLocationData)
        : {
            ItemGridInfo: [],
            SiteGridInfo: [],
            SiteGroupGridInfo: [],
          };
      if (this.state.isRightGridFiltered || this.state.isLeftGridFiltered) {
        let submitValues = {
          GroupId_Location: values.GroupId_Location,
        };
        if (this.state.isRightGridFiltered) {
          const sortedData = this.rightSideGridReactTableRef.current.getResolvedState()
            .sortedData;
          const itemSortedDataCopy = getFilteredIds(
            sortedData,
            ItemEnum.ItemId
          );
          let gridItems = _.intersection(
            itemSortedDataCopy,
            values.ItemGridInfo
          );
          _.remove(ItemGridInfo, ItemId => {
            return itemSortedDataCopy.indexOf(ItemId) > -1;
          });
          submitValues.ItemGridInfo = _.union(gridItems, ItemGridInfo);
        } else {
          submitValues = {
            ...values,
            ...submitValues,
          };
        } //end of isRightGridFiltered if condition
        if (this.state.isLeftGridFiltered) {
          let leftGridFormValue, leftGridInitialValues;
          if (
            renderedComponent ===
            ComponentMapping.SiteToItemsComponentsWithStorageLocation
          ) {
            leftGridFormValue = values.SiteGridInfo;
            leftGridInitialValues = SiteGridInfo;
            leftGridPayloadName = AssignEntitiesEnum.SiteGridInfo;
          } else if (
            renderedComponent ===
            ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation
          ) {
            leftGridFormValue = values.SiteGroupGridInfo;
            leftGridInitialValues = SiteGroupGridInfo;
            leftGridPayloadName = AssignEntitiesEnum.SiteGroupGridInfo;
          }
          const sortedData = this.leftSideGridReactTableRef.current.getResolvedState()
            .sortedData;
          const leftGridSortedData = getFilteredIds(sortedData, SiteEnum.Id);
          let leftGridIds = _.intersection(
            leftGridSortedData,
            leftGridFormValue
          );
          //remove un-checked values
          _.remove(leftGridInitialValues, id => {
            return leftGridSortedData.indexOf(id) > -1;
          });
          submitValues[leftGridPayloadName] = _.union(
            leftGridIds,
            leftGridInitialValues
          );
        } else {
          submitValues = {
            ...values,
            ...submitValues,
          };
        } //end of if-else isLeftGridFiltered condition
        payload = getPayload(submitValues, renderedComponent);
      } else {
        //end of main if
        payload = getPayload(values, renderedComponent);
      }
      if (payload) {
        this.setState({
          isReadOnly: true,
        });
        this.props.saveAssignEntities(payload, renderedComponent).then(() => {
          callApiBasedOnRenderComponent(
            this.props,
            renderedComponent,
            this.onResetPageOnDataChange
          );
        });
      }
    }
  };
  onSaveClick = () => {
    this.props.submitForm(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME);
  };

  componentWillUnmount() {
    const { allTableStates, setTableStates } = this.props;
    this.props.resetForm(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME);
    this.clearTableSavedState();
    setTableStates({
      ...allTableStates,
      [TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_ITEM_GRID_TABLE]: DefaultTableState,
      [TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_SITE_GRID_TABLE]: DefaultTableState,
    });
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_ITEM_GRID_TABLE,
      TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_SITE_GRID_TABLE,
    ]);
  };
  setIsReadOnlyState = isReadOnly => {
    this.setState({
      isReadOnly: isReadOnly,
    });
  };

  onRightGridFilteredChange = filtered => {
    this.setState({
      isRightGridFiltered: Boolean(filtered && filtered.length),
    });
  };

  onLeftGridFilteredChange = filtered => {
    this.setState({
      isLeftGridFiltered: Boolean(filtered && filtered.length),
    });
  };

  handleNoSitesDialog = () => {
    this.setState({ showNoSitesModal: false });
  };

  render() {
    const { fetchingDropDown } = this.props;
    const initialValues = {
      SortOptions: AssignEntitiesEnum.Site,
      SiteGridInfo: [],
      ItemGridInfo: [],
      SiteGroupGridInfo: [],
      [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Location]: GenericEnum.InitialFilterValue,
    };

    return fetchingDropDown ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter
          title={'Assign Storage Location'}
          style={{
            width: 400,
          }}
        />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={this.state.isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <StorageLocationForm
                onSubmit={this.handleSubmit}
                changeGrid={this.changeGrid}
                initialValues={initialValues}
                SiteToItemsComponentsWithStorageLocation={
                  this.state.render.SiteToItemsComponentsWithStorageLocation
                }
                setIsReadOnlyState={this.setIsReadOnlyState}
                isReadOnly={this.state.isReadOnly}
                isRightGridFiltered={this.state.isRightGridFiltered}
                onRightGridFilteredChange={this.onRightGridFilteredChange}
                rightSideGridReactTableRef={this.rightSideGridReactTableRef}
                isLeftGridFiltered={this.state.isLeftGridFiltered}
                leftSideGridReactTableRef={this.leftSideGridReactTableRef}
                onLeftGridFilteredChange={this.onLeftGridFilteredChange}
                resetGridPage={this.state.resetGridPage}
                onResetPageOnDataChange={this.onResetPageOnDataChange}
              />
            </Main>
          )}
        </DirtyWrapper>
        <NotificationDialog
          title={'Assign Entities'}
          showDialog={this.state.showNoSitesModal}
          message={
            'Please select at least one Site/SiteGroup to assign items for selected Storage Location.'
          }
          onOkClick={this.handleNoSitesDialog}
        />
      </Fragment>
    );
  }
}
const selector = formValueSelector(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME)(state)
  );

  return {
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    storageLocationValue: selector(state, FilterEnum.GroupId_Location),
    allTableStates: getTableStates(state),

    allSitesLoadingError: Selectors.getAllSitesLoadingError(state),
    allItemsLoadingError: Selectors.getAllItemsLoadingError(state),
    siteGroupLoadingError: Selectors.getSiteGroupLoadingError(state),
    storageLocationByIdLoadingError: Selectors.getStorageLocationByIdLoadingError(
      state
    ),
    submitted: Selectors.getSubmitted(state),
    isSubmitting: Selectors.getIsSubmitting(state),
    submitError: Selectors.getSubmitError(state),
    submitSuccessMsg: Selectors.getSubmitSuccessMsg(state),
    assignedStorageLocationData: Selectors.getAssignedStorageLocationData(
      state
    ),

    acctCategoryDataError: FilterSelectors.getAcctCategoryDataError(state),
    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    storageLocationDataError: FilterSelectors.getStorageLocationDataError(
      state
    ),
    fetchingDropDown:
      FilterSelectors.getAcctCategoryDataLoading(state) ||
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state) ||
      FilterSelectors.getStorageLocationDataLoading(state),
  };
};

const mapDispatchToProps = {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getStorageLocationForCurrentSite,
  getItems,
  getAllSites,
  getSiteSiteGrpItemByStorageLoc,
  submitForm,
  resetForm,
  clearSubmitError,
  saveAssignEntities,
  getSiteGroupData,
  resetAssignEntitiesStoragePage,
  setTableStates,
  clearTableSavedState,
};

export const StorageLocationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageLocation);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/storageLocation/StorageLocation.js